import { useTranslation } from 'react-i18next'

const DAY_MONTH_FORMATS: Record<string, string> = {
  de: 'dd.',
  en: 'dd',
}

export const useDayMonthFormat = (monthCharactersLength = 3) => {
  const lang = useTranslation().i18n.language
  const monthsFormat = new Array(monthCharactersLength).fill('M').join('')

  return `${DAY_MONTH_FORMATS[lang]} ${monthsFormat}`
}
